import React, { useState } from 'react';

function UploadModal({ show, onClose, handleUpload }) {
  const [selectedFile, setSelectedFile] = useState(null);

  const onFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const onUpload = () => {
    if (selectedFile) {
      handleUpload(selectedFile);
      setSelectedFile(null);
    } else {
      alert('Por favor, selecione um arquivo para upload.');
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Upload de Arquivo</h5>
            <button type="button" className="close" onClick={onClose} aria-label="Fechar">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <input type="file" onChange={onFileChange} />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Fechar
            </button>
            <button type="button" className="btn btn-primary" onClick={onUpload}>
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UploadModal;
